import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import i18n from '@/i18n.js';
import ApiService from '@/api/service';
import { initFilters } from './common/filters';

Vue.config.productionTip = false;
ApiService.init();
Vue.prototype.$eventHub = new Vue();

initFilters(Vue);
new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
